/* eslint-disable react/require-default-props */
import PropTypes from "prop-types";
import Modal from "@shared/v2/Modal";
import Button from "@shared/v2/Button/Button";

const formatAgentNames = (agentNames) => {
  if (agentNames.length === 1) return agentNames[0];
  if (agentNames.length === 2) return `${agentNames[0]} and ${agentNames[1]}`;

  return `${agentNames.slice(0, -1).join(", ")}, and ${agentNames.at(-1)}`;
};

const AppointmentRemoveWarning = ({ show, onClose, onSubmit, previousAgents }) => {
  const agentNames = previousAgents.length > 0 ? previousAgents : ["someone"];
  const formattedAgentNames = formatAgentNames(agentNames);
  const appointmentCopy =
    agentNames.length === 1 ? "an upcoming appointment" : "upcoming appointments";

  return (
    <Modal
      className="tw-flex tw-justify-center tw-items-center"
      dialogClassName="tw-h-auto"
      contentClassName="tw-w-[440px] tw-h-full tw-flex tw-flex-col tw-gap-32px"
      show={show}
      onHide={onClose}
    >
      <Modal.Header
        titleClassName="tw-text-neutral-gray-75"
        title="Appointment Access Warning"
        closeButton
      />

      <Modal.Body>
        <p className="tw-text-14d tw-leading-[20px] tw-text-neutral-gray-75">
          {`Reassigning will revoke ${formattedAgentNames}'s access to this contact profile. They have ${appointmentCopy} scheduled and will no longer be able to view this contact's information.`}
        </p>
      </Modal.Body>

      <Modal.Footer className="tw-flex tw-justify-between">
        <Button onClick={onClose} schema="tertiary" size="medium">
          Cancel
        </Button>
        <Button onClick={onSubmit} schema="warning" size="medium">
          Yes, reassign
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

AppointmentRemoveWarning.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  previousAgents: PropTypes.arrayOf(PropTypes.string),
};

AppointmentRemoveWarning.defaultProps = {
  show: false,
  onClose: null,
  onSubmit: null,
  previousAgents: ["someone"],
};

export default AppointmentRemoveWarning;
